import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import useAuthStore from '../../stores/authStore'
import Spinner from 'react-bootstrap/Spinner'

const GuardRoute = ({ children }) => {
    const { token, loadUserFromLocalStorage } = useAuthStore()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const loadToken = async () => {
            await loadUserFromLocalStorage()
            setLoading(false)
        }

        loadToken()
    }, [loadUserFromLocalStorage])

    if (loading) {
        return <></>
    }

    return token ? children : <Navigate to="/login" />
}

export default GuardRoute
